<template>
	<div class="container" id="BioTestingQuizResults">
		<div class="row text-center gold mt-2">
			<h3 class="col-12">BioTesting Quiz Results</h3>

			<div class="col-sm-6 text-left">
				<BioTestingButtons title='<i class="fas fa-home"></i> Admin Quiz Actions' />
			</div>

			<p class="col-sm-6 text-right">
				<span v-text="profile_name"></span> - <span v-text="quizTitle"></span><br />
				<small>Date submitted: <i v-text="date_submitted"></i></small>
			</p>
		</div>

		<div v-if="sections.length > 0">
			<div v-for="(section, Skey) in sections" :key="Skey" class="mb-2">
				<div class="card">
					<h5 class="card-header">
						<span v-text="section.data.question"></span>
					</h5>

					<div class="card-body">
						<b-table hover small borderless :fields="fields" :items="section.questions">
							<template v-slot:table-busy>
								<div class="text-center my-2 p-2">
									<b-spinner class="align-middle"></b-spinner>
									<br />
									<strong>Loading...</strong>
								</div>
							</template>

							<template v-slot:cell(question)="data">
								{{ data.item.title }}
							</template>

							<template v-slot:cell(answer)="data">
								{{ data.item.answer_selected }}
							</template>

							<template v-slot:cell(frequency)="data">
								{{ data.item.frequency_selected }}
							</template>

							<template slot="bottom-row">
								<td class="pt-4 text-right">
									Sub total:<br />
									<hr />
									<b>Total:</b>
								</td>
								<td class="pt-4 text-center">
									<i v-text="sectionTotal(Skey, 'A')"></i><br />
									<hr />
									<b v-text="sectionTotal(Skey, 'T')"></b>
								</td>
								<td class="pt-4 text-center">
									<i v-text="sectionTotal(Skey, 'F')"></i><br />
									<hr />
								</td>
							</template>
						</b-table>
					</div>
				</div>
			</div>
		</div>

		<div v-else class="text-center mt-5 gold">
			<div v-if="message != ''">
				<b-alert show variant="primary">{{ message }}</b-alert>
			</div>
			<div v-else>
				<i class="fas fa-spinner fa-spin fa-2x"></i>
				<p>Loading Data...</p>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import BioTestingButtons from '../components/BioTestingButtons.vue';

export default {
	name: 'BioTestingQuizResults',
	components: {
		BioTestingButtons,
	},
	props: {},
	data() {
		return {
			fields: [
				{ key: 'question', sortable: false, label: 'Questions', class: 'question' },
				{ key: 'answer', sortable: false, label: 'Answer', class: 'text-center' },
				{ key: 'frequency', sortable: false, label: 'Frequency', class: 'text-center' },
			],

			message: '',
			date_submitted: '',
			profile_name: '',
			quizTitle: '',
			sections: [],
		};
	},
	methods: {
		sectionsLoad(answersID) {
			let _this = this;

			_this.sections = [];
			_this.message = '';
			_this.date_submitted = '';
			_this.quizTitle = '';
			_this.profile_name = '';

			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('answers_id', answersID);

			axios({
				url: _this.$store.state.api_url + 'bio_testing_answers_load',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						const Q = Object.values(response.data.sections);
						for (const key of Q) {
							_this.sections.push(key);
						}
						_this.sections[0].data.collapse = true;
						_this.sections_total = _this.sections.length;
						_this.quizTitle = response.data.title;
						_this.profile_name = response.data.profile_name;
						_this.date_submitted = response.data.date_submitted;

						_this.sectionAnsweredCount();
					} else if (response.data.status == 2) {
						_this.message = response.data.message;
					}
				})
				.catch(function () {});
		},

		sectionTotal(k, field) {
			var val = 0;
			if (field == 'A') {
				val = this.sections[k].data.answer_total;
			} else if (field == 'F') {
				val = this.sections[k].data.frequency_total;
			} else if (field == 'T') {
				val = this.sections[k].data.frequency_total + this.sections[k].data.answer_total;
			}
			return val;
		},
	},
	computed: {
		answersID() {
			return this.$route.params.result_id;
		},
	},
	created() {},
	mounted() {
		this.sectionsLoad(this.answersID);
	},
	watch: {},
};
</script>

<style>
.question {
	width: 75%;
}
</style>
